import gsap from "gsap";

function getRandomDirection(){
  let theta = Math.random()*Math.PI*2
  let x = 300*Math.sin(theta)
  let y = 300*Math.cos(theta)
  return {x,y}
}

function initFooter(){

// setTimeout(() => {
  let animation = gsap.timeline({
    onUpdate: (args) => {
      console.log("arg");
    },
    scrollTrigger: {
      // scroller: ".scrollContainer",
      scrub: true,
      trigger: ".footer",
      start: "top bottom",
      //   end: pinWrapWidth
      end: "bottom bottom",
      refreshPriority: 100,
      onEnterBack: () => {
        //   if (!this.play) this.play = true;
        //   this.render();
      },
      onEnter: () => {
        //   if (!this.play) this.play = true;
        //   this.render();
        // alert("enter");
      },
      onLeave: () => {
        //   this.play = false;
        //   console.warn("LEAVE SELECTED");
      },
      onLeaveBack: () => {
        //   this.play = false;
      },
      onUpdate: (args) => {
        //   console.log("UPDATE SELECTED", args.progress);
        // this.progress = args.progress;
        // this.update()
      },
    },
  });


  for (let i = 1; i <= 5; i++) {
    let dir = getRandomDirection()
    animation.fromTo(
      `.footer-mirror__wraptext span:nth-child(${i})`,
      {
        x: dir.x,
        y: dir.y,
      },
      {
        x: 0,
        y: 0,
        duration: 0.3,
        ease: "power2.out"
      },
      0
    );
    
  }

}

if(document.querySelector(".footer-mirror__wraptext")){
  initFooter()
}

